export default function Logo() {
  return (
    <div style={{ gap: 6, textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
      <img style={{ height: 28, width: 28 }} src='/favicon.svg' alt='evaro' />
      <span className='text-primary font-bold text-[19px]'>Prescribers</span>
    </div>
  )
}
